import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { DatapointLookupEffects } from './datapoint-lookup.effects';
import { reducer } from './datapoint-lookup.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('datapointLookup', reducer),
    EffectsModule.forFeature([DatapointLookupEffects]),
  ],
  providers: [DatapointLookupEffects],
})
export class DatapointLookupStoreModule {}
